const SituacaoCliente = {
    VERMELHO : 'VERMELHO',
    AZUL : 'AZUL',
    AMARELO : 'AMARELO',
    VERDE : 'VERDE'
}

export default SituacaoCliente;